"use client";

import React, { useState } from "react";
import { Box, Typography, styled } from "@mui/material";
import {
  SectionHeader,
  SectionContent,
  Label,
  Value,
  RightColumn,
} from "./styles/SharedStyles";
import EditButton from "@components/shared/EditButton";
import EditPersonalDetails from "../modals/EditPersonalDetails";
import isPlaceholderEmail from "@lib/candidates/isPlaceholderEmail";

const DetailRow = styled(Box)({
  display: "flex",
  gap: "8px",
});

const PersonalDetails = ({ candidate, onUpdate }) => {
  const [openEditDetails, setOpenEditDetails] = useState(false);

  const email = isPlaceholderEmail(candidate.email) ? "" : candidate.email;

  return (
    <>
      <Box>
        <SectionContent>
          <EditButton onEdit={() => setOpenEditDetails(true)} sx={{ top: 0, right: 0 }} />
          <Box>
            <RightColumn>
              <SectionHeader>
                <Typography variant="h2">Personal details</Typography>
              </SectionHeader>
              <DetailRow>
                <Label>Name:</Label>
                <Value>{candidate.name}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Position:</Label>
                <Value>{candidate.position_title}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Location:</Label>
                <Value>{candidate.address_address}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Email address:</Label>
                <Value>{email}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Phone:</Label>
                <Value>{candidate.phone}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Available for hire:</Label>
                <Value>{candidate.available_now ? "Yes" : "No"}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Type of work:</Label>
                <Value>{candidate.type_of_work}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Salary expectations:</Label>
                <Value>{candidate.salary}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Languages:</Label>
                <Value>{candidate.languages_spoken}</Value>
              </DetailRow>
              <DetailRow>
                <Label>Personal website:</Label>
                <Value>
                  {candidate.website && (
                    <a href={candidate.website} target="_blank" rel="noopener noreferrer">
                      {candidate.website}
                    </a>
                  )}
                </Value>
              </DetailRow>
              <DetailRow>
                <Label>LinkedIn profile:</Label>
                <Value>
                  {candidate.linkedin && (
                    <a href={candidate.linkedin} target="_blank" rel="noopener noreferrer">
                      {candidate.linkedin}
                    </a>
                  )}
                </Value>
              </DetailRow>
              <DetailRow>
                <Label>GitHub profile:</Label>
                <Value>
                  {candidate.github && (
                    <a href={candidate.github} target="_blank" rel="noopener noreferrer">
                      {candidate.github}
                    </a>
                  )}
                </Value>
              </DetailRow>
            </RightColumn>
          </Box>
        </SectionContent>
      </Box>
      <EditPersonalDetails
        onClose={() => setOpenEditDetails(false)}
        open={openEditDetails}
        candidate={candidate}
        onUpdate={onUpdate}
      />
    </>
  );
};

export default PersonalDetails;